var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1067 11.2468C10.04 11.2402 9.96004 11.2402 9.88671 11.2468C8.30004 11.1935 7.04004 9.8935 7.04004 8.2935C7.04004 6.66016 8.36004 5.3335 10 5.3335C11.6334 5.3335 12.96 6.66016 12.96 8.2935C12.9534 9.8935 11.6934 11.1935 10.1067 11.2468Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9399 6.6665C16.2333 6.6665 17.2733 7.71317 17.2733 8.99984C17.2733 10.2598 16.2733 11.2865 15.0266 11.3332C14.9733 11.3265 14.9133 11.3265 14.8533 11.3332",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77323 13.7065C5.1599 14.7865 5.1599 16.5465 6.77323 17.6198C8.60657 18.8465 11.6132 18.8465 13.4466 17.6198C15.0599 16.5398 15.0599 14.7798 13.4466 13.7065C11.6199 12.4865 8.61323 12.4865 6.77323 13.7065Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2266 17.3335C16.7066 17.2335 17.1599 17.0402 17.5332 16.7535C18.5732 15.9735 18.5732 14.6868 17.5332 13.9068C17.1666 13.6268 16.7199 13.4402 16.2466 13.3335",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.a60a696f39b7852b4b1ccccc10b9c545.svg";
export { ForwardRef as ReactComponent };